import { defineFormFactory } from "@/pages/apply/application/factories/define-form-factory"
import {
  PrimaryPersonalInformation,
  PurchaseInformation,
} from "@/pages/apply/application/sections"

export const AccountLookupFormFactory = defineFormFactory("account-lookup", {
  steps: ["personal"],
  primarySections: (context) => {
    if (context.id === "personal") {
      return [PurchaseInformation, PrimaryPersonalInformation]
    }
    return []
  },
  jointSections: () => [],
  jointSteps: [],
  done: () => "/apply/workflows/account-lookup/lookup",
})

export const getAccountLookupFields = (): string[] => {
  return [...PurchaseInformation.fields, ...PrimaryPersonalInformation.fields]
}
